<template>
  <div class="courseListPage" :class="[_isMobile() ? 'courseListMobilePage' : '']">
    <ul class="classBox">
      <li class="classList">
        <a-row type="flex" justify="start">
            <a-col :xs="24" :sm="24" :md="1">主题：</a-col>
            <a-col :xs="24" :sm="24" :md="22">
                <span v-for="item,index in 8" :key="index" class="tyleList">{{ item }}</span>
            </a-col>
        </a-row>
      </li>
      <li class="classList">
        <a-row type="flex" justify="start">
            <a-col :xs="24" :sm="24" :md="1">学段：</a-col>
            <a-col :xs="24" :sm="24" :md="22">
                <span v-for="item,index in 8" :key="index" class="tyleList">{{ item }}</span>
            </a-col>
        </a-row>
      </li>
      <li class="classList">
        <a-row type="flex" justify="start">
            <a-col :xs="24" :sm="24" :md="1">活动：</a-col>
            <a-col :xs="24" :sm="24" :md="22">
                <span v-for="item,index in 8" :key="index" class="tyleList">{{ item }}</span>
            </a-col>
        </a-row>
      </li>
    </ul>
    <ul class="classBox">
      <li class="classList">
        <a-row type="flex" justify="start">
            <a-col :xs="24" :sm="24" :md="1">排序：</a-col>
            <a-col :xs="24" :sm="24" :md="6">
                <span v-for="item,index in 5" :key="index" class="tyleList tyleListText">{{ item }}</span>
            </a-col>
            <a-col :xs="24" :sm="24" :md="1">难度：</a-col>
            <a-col :xs="24" :sm="24" :md="6">
                <span v-for="item,index in 5" :key="index" class="tyleList tyleListText">{{ item }}</span>
            </a-col>
            <a-col :xs="24" :sm="24" :md="1">类型：</a-col>
            <a-col :xs="24" :sm="24" :md="6">
                <span v-for="item,index in 5" :key="index" class="tyleList tyleListText">{{ item }}</span>
            </a-col>
        </a-row>
      </li>
    </ul>
    <a-row :gutter="_isMobile() ? [0, 20] : [20, 20]">
      <a-col :xs="24" :sm="24" :md="6" v-for="(item, index) in 6" :key="index">
        <div class="courseList" @click="openDetailsFn(item)">
            <div class="courseImage">
                <img src="../../assets/aice2/kec_image.png"  class="" alt=""/>
                <div class="listType" :style="{'background':listTyleColir[Math.floor(Math.random() * listTyleColir.length)]}">案例课</div>
                <div class="listnum">21课时</div>
            </div>
          <p class="p1">课程名称</p>
          <p class="p2">课程来源</p>
          <div class="courseFooter">
            <div class="courserType">讲师姓名</div>
            <div class="courserOverview">
              <span v-for="(v, i) in 3" :key="i"
                ><i v-if="v != 1">|</i> {{ v }}
              </span>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
  <script>
import { mixinDevice } from "@/utils/mixin.js";
export default {
  mixins: [mixinDevice],
  name: "",
  components: {},
  data() {
    return {
      backgroundList: ["#AE5DA1", "#EC6941", "#32B16C", "#556FB5"],
      listTyleColir:['linear-gradient(90deg, #8FFCA0, #0BCBFB)','linear-gradient(90deg, #C82090, #6A14D1)'],
      classActive: 1,
    };
  },
  created() {},
  mounted() {},
  methods: {
    openMoreFn() {
      this.$router.push({ path: "/course/list" });
    },
    openDetailsFn(item){
      this.$router.push({path:'/course/detail'})
    }
  },
};
</script>
  <style lang='scss' scoped>
  .courseListMobilePage{
    .classBox{
        padding: 10px !important;
    }
    .classList {
        padding: 10px 0 !important;
    }
    .classList:last-child{
        padding: 10px 0 0 0 !important;
    }
  }
.courseListPage {
  width: 100%;
  p {
    margin: 0;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .courseList:hover {
    box-shadow: 2px 2px 6px 0px rgba(91, 106, 140, 0.36);
  }
  .courseList {
    width: 100%;
    height: auto;
    cursor: pointer;

    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #d2d2d2;
    .courseFooter {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      font-size: 16px;
      color: #666666;
    }
    .courseImage {
      width: 100%;
      height: 180px;
      border-radius: 10px 10px 0 0;
      position: relative;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;

      }
      .listType{
        position: absolute;
        top: 10px;
        right: 0;
        z-index: 9;
        line-height: 24px;
        width: auto;
        padding: 0 9px;
        font-size: 14px;
        color: #FFFFFF;
        height: 24px;
        background: linear-gradient(90deg, #8FFCA0, #0BCBFB);
        border-radius: 11px 0px 0px 11px;
      }
      .listnum{
        width: auto;
        padding: 0 9px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 24px;
        height: 24px;
        background: #00000031;
        border-radius: 12px;
        position: absolute;
        right: 10px;
        bottom: 10px;
        z-index: 9;
      }
    }
    .p1 {
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      padding: 14px 10px 6px 10px;
    }
    .p1:hover {
      color: #184dd5;
    }
    .p2 {
      font-size: 16px;
      color: #666666;
      padding: 0 10px;
    }
  }
  .classBox {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background: #F7F8FA;
    border-radius: 5px;
    border: 1px solid #7D7D7D;
    margin-bottom: 12px;
    .classList {
        font-size: 16px;
        color: #333333;
        padding: 20px 0;
        border-bottom: 1px solid #D2D2D2;
    }
    .classList:last-child{
        border: none;
        padding: 20px 0 0 0;
    }
    .classList:first-child{
        padding-top: 0;
    }
    .tyleList{
        display: inline-block;
        padding: 0 10px;
        margin-right: 15px;
        cursor: pointer;
        border-radius: 5px;
    }
     .tyleList:hover {
      background: #184dd5;
      color: #fff;
      border-color: #184dd5;
    }
    .tyleListActive {
      background: #184dd5 !important;
      color: #fff !important;
      border-color: #184dd5 !important;
    }
    .tyleListText:hover{
        color: #184dd5 !important;
        background: transparent !important;
    }
  }
}
</style>
  